import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.function.name.js";
var prefix = "wui";

var WebUI = function WebUI(config) {
  var name = config.name,
      defaultProps = config.defaultProps,
      propTypes = config.propTypes;

  if (!name) {
    console.error("请输入组件名");
    return;
  }

  return function (Comp) {
    var pre = [prefix, name.toLowerCase()].join("-");
    Comp.defaultProps = _objectSpread(_objectSpread({}, defaultProps), {
      clsPrefix: pre
    });
    if (propTypes) Comp.propTypes = propTypes;
    return Comp;
  };
};

export { prefix };
export default WebUI;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-core/src/updatePrefix.js